// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .content {
  padding: 1rem;
}
:host .message-textarea {
  margin-bottom: 0px !important;
  --border-width: 1px;
  --border-color: var(--ion-color-light);
  --border-radius: 5px;
  border-radius: 5px;
}
:host .message-textarea ion-textarea {
  padding: 10px 15px;
  font-size: 0.9rem;
}
:host .char-counters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
:host .char-counters ion-button {
  pointer-events: all;
  display: inline-block;
  opacity: 1;
}
:host .char-counters ion-button.hide {
  opacity: 0;
  pointer-events: none;
}
:host .char-counters p {
  color: var(--ion-color-medium);
  font-size: 12px;
}
:host .char-counters p.danger {
  color: var(--ion-color-danger);
}
:host .photo-placeholder {
  --padding-start: 0;
  width: 100%;
  margin-bottom: 1em;
  background-color: var(--ion-color-light);
  border-radius: 8px;
  cursor: pointer;
  --inner-padding-end: 10px;
  --inner-padding-start: 10px;
  --inner-padding-top: 15px;
  position: relative;
}
:host .photo-placeholder i {
  position: absolute;
  top: 7px;
  right: 7px;
  border-radius: 50%;
  padding: 11px;
  height: 30px;
  width: 30px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f8;
  color: var(--cms-button-bg-color);
  box-shadow: 0 0 8px 3px #b8b8b8;
  z-index: 10;
}
:host .photo-placeholder img {
  width: 100%;
  text-align: center;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/components/wall/new-wall-item-modal/new-wall-item-modal.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAGE;EACE,6BAAA;EACA,mBAAA;EACI,sCAAA;EACA,oBAAA;EACA,kBAAA;AADR;AAEI;EACE,kBAAA;EACA,iBAAA;AAAN;AAIE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAFJ;AAII;EACE,mBAAA;EACA,qBAAA;EACA,UAAA;AAFN;AAGM;EACE,UAAA;EACA,oBAAA;AADR;AAKI;EACE,8BAAA;EACA,eAAA;AAHN;AAKM;EACE,8BAAA;AAHR;AAQE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;AANJ;AAQI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,+BAAA;EACA,WAAA;AANN;AASI;EACE,WAAA;EAEA,kBAAA;EACA,iBAAA;AARN","sourcesContent":[":host {\n  .content {\n    padding: 1rem;\n  }\n\n  .message-textarea {\n    margin-bottom: 0px !important;\n    --border-width: 1px;\n        --border-color: var(--ion-color-light);\n        --border-radius: 5px;\n        border-radius: 5px;\n    ion-textarea {\n      padding: 10px 15px;\n      font-size: 0.9rem;\n    }\n  }\n\n  .char-counters {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n\n    ion-button {\n      pointer-events: all;\n      display: inline-block;\n      opacity: 1;\n      &.hide {\n        opacity: 0;\n        pointer-events: none;\n      }\n    }\n\n    p {\n      color: var(--ion-color-medium);\n      font-size: 12px;\n\n      &.danger {\n        color: var(--ion-color-danger);\n      }\n    }\n  }\n\n  .photo-placeholder {\n    --padding-start: 0;\n    width: 100%;\n    margin-bottom: 1em;\n    background-color: var(--ion-color-light);\n    border-radius: 8px;\n    cursor: pointer;\n    --inner-padding-end: 10px;\n    --inner-padding-start: 10px;\n    --inner-padding-top: 15px;\n    position: relative;\n\n    i {\n      position: absolute;\n      top: 7px;\n      right: 7px;\n      border-radius: 50%;\n      padding: 11px;\n      height: 30px;\n      width: 30px;\n      display: flex !important;\n      align-items: center;\n      justify-content: center;\n      background-color: #f4f5f8;\n      color: var(--cms-button-bg-color);\n      box-shadow: 0 0 8px 3px #b8b8b8;\n      z-index: 10;\n    }\n\n    img {\n      width: 100%;\n      //max-height: 200px;\n      text-align: center;\n      object-fit: cover;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
